var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,0.5C6.6,0,6-0.1,5.5,0.1C5,0.4,4.9,1,5.1,1.5l1,1.7C6.3,3.6,6.7,3.7,7,3.7c0.2,0,0.3,0,0.5-0.1 C8,3.3,8.1,2.7,7.9,2.2L6.9,0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,8.7c0.4,0,0.8-0.3,0.9-0.7C4.1,7.6,3.9,7,3.3,6.8l-2-0.7C0.8,5.9,0.3,6.1,0.1,6.7c-0.2,0.5,0.1,1.1,0.6,1.3 l2,0.7C2.8,8.7,2.9,8.7,3,8.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,13.9l-2,1.3c-0.5,0.3-0.6,0.9-0.3,1.4C1.3,16.8,1.7,17,2,17c0.2,0,0.4,0,0.5-0.2l2-1.3 c0.5-0.3,0.6-0.9,0.3-1.4C4.5,13.7,3.9,13.6,3.5,13.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6,4.9C13.7,5,13.8,5,14,5c0.4,0,0.7-0.2,0.9-0.6l1-2c0.2-0.5,0-1.1-0.4-1.3c-0.5-0.2-1.1,0-1.3,0.4l-1,2 C12.9,4,13.1,4.6,13.6,4.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7,22.3l-4.5-4.5l3.5-1.6c0.4-0.2,0.6-0.5,0.6-0.9c0-0.4-0.3-0.8-0.6-0.9L9.4,8.1C9,7.9,8.6,8,8.3,8.3 C8,8.6,7.9,9,8.1,9.4l6.3,16.2c0.1,0.4,0.5,0.6,0.9,0.6c0.4,0,0.8-0.2,0.9-0.6l1.6-3.5l4.5,4.5c0.2,0.2,0.4,0.3,0.7,0.3 s0.5-0.1,0.7-0.3l3-3c0.2-0.2,0.3-0.4,0.3-0.7C27,22.7,26.9,22.5,26.7,22.3z M23,24.6l-4.8-4.8c-0.2-0.2-0.4-0.3-0.7-0.3 c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.6,0.3-0.7,0.6l-1.2,2.6l-4.6-11.9l11.9,4.6L20,16.6c-0.3,0.1-0.5,0.4-0.6,0.7 c-0.1,0.3,0,0.7,0.3,0.9l4.8,4.8L23,24.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.3f0d867ae31f5d2d70d36282b41b43b2.svg";
export { ForwardRef as ReactComponent };